// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"67e85a04","703":"e1b077bf"}[chunkId] + ".chunk.js";
};